<template>
  <div>
    <el-dialog
      title="Logoyu Kırp"
      :visible.sync="dialogVisible"
      :width="width"
      :before-close="handleClose">

      <vue-cropper
        ref="cropper"
        :src="img_url"
        :aspectRatio="4/3"
        :initialAspectRatio="4/3"
        dragMode="move"
        :minCropBoxWidth="800"
        :minCropBoxHeight="600"
        :cropBoxResizable="false"
        :checkCrossOrigin="false"
      >
      </vue-cropper>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">İptal Et</el-button>
        <el-button type="primary" @click="crop">Onayla</el-button>
      </span>
    </el-dialog>
    <el-upload
        class="upload-demo"
        drag
        accept="image/jpeg,image/png"
        action=""
        :on-change="pathChange"
        :multiple="false"
        :limit="1"
        :file-list="key_path"
        :auto-upload="false"
        :before-remove="removeImage">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">Logonuzu buraya sürükleyin ya da <em>buraya tıklayın</em></div>
      <div class="el-upload__tip text-danger font-weight-bold" slot="tip">Sadece jpg/png formatları kabul edilmektedir.</div>
    </el-upload>
  </div>
</template>

<script>
import * as axios from "axios";
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
export default {
  components: {
		VueCropper
	},
  data() {
    return {
      width: '30%',
      key_path: [],
      file: null,
      img_url: null,
      dialogVisible: false
    }
  },
  created() {
    this.getWidth();
  },
  methods: {
    getWidth() {
      if (window.innerWidth < 760) {
        this.width = "90%";
      } else {
        this.width = "30%";
      }
    },
    pathChange (file, fileList) {
      this.img_url = URL.createObjectURL(file.raw);
      this.file = file;
      this.key_path = fileList;
      this.dialogVisible = true;
      //console.log(this.img_url);
    },
    crop() {
      const canvas = this.$refs.cropper.getCroppedCanvas({ width: 800, height: 600 });
      canvas.toBlob(blob => {

        // You can use axios, superagent and other libraries instead here
          blob.lastModifiedDate = new Date();
          blob.lastModified = blob.lastModifiedDate.getTime();
          blob.uid = blob.lastModifiedDate.getTime();
          blob.name = this.file.raw.name;
          this.file.raw = blob;
          this.handleFile();
      }, this.file.raw.type);
		},
    async handleFile() {
      let formData = new FormData();
      formData.append('logo',this.file.raw);
      //console.log(formData);
      await axios.post('company/logo', formData, { headers: { 'Content-Type' : 'multipart/form-data' }}).then(response => {
        if (response.status === 200) {
          this.$notify.success({
            title: 'Başarılı',
            message: 'Bilgi güncellemesi başarıyla gerçekleştirildi.',
          });
          this.$router.go(this.$router.currentRoute);
        }
      })
      .catch((err) => {
        if (err.response.status === 406) {
          let messages = err.response.data;
          messages.forEach(message => {
            this.$notify.error({
              title: 'Başarısız',
              message,
            });
          });
        }
      })
      .finally(() => {
        this.removeImage();
      });
    },
    handleClose(done) {
      this.$confirm('İşlemi iptal etmek istediğinize emin misiniz?')
        .then(()=> {
          this.removeImage();
          done();
        })
        .catch(()=> {});
    },
    defaultSize() {
			return {
				width: 800,
				height: 600,
			};
    },
    removeImage() {
      this.dialogVisible = false
      this.img_url = null;
      this.file = null;
      this.key_path = [];
    }
  }
}
</script>

<style>
.cropper {
  background: transparent;
}
.handler {
    position: absolute;
    right: 15%;
    top: 14%;
    z-index: 1;
    cursor: ne-resize;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.line {
	border-style: dashed;
	border-color: rgba(133, 133, 133, 0.712);
}

.cropper-background {
  background-color: transparent;
}
.el-upload-dragger{
  width: auto!important;
}
</style>
